import React from 'react';

const File = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <mask id="mask0" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="14">
      <path
        d="M2 0H8.5L12 3.5V12C12 13.1046 11.1046 14 10 14H2C0.89543 14 0 13.1046 0 12V2C0 0.89543 0.89543 0 2 0ZM8 0.5V4H11.5L8 0.5Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        d="M2 0H8.5L12 3.5V12C12 13.1046 11.1046 14 10 14H2C0.89543 14 0 13.1046 0 12V2C0 0.89543 0.89543 0 2 0ZM8 0.5V4H11.5L8 0.5Z"
        fill="#C5D0DB"
      />
    </g>
  </svg>
);

export default File;
